import {
    DELETE_GITHUB_AUTHENTICATION,
    GET_GITHUB_AUTHENTICATION_INFO,
    SET_GITHUB_AUTHENTICATION
} from 'app/lib/types/server';
import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('github');

export const GET_GITHUB_AUTHENTICATION_INFO_ACTION_TYPE = apiType(GET_GITHUB_AUTHENTICATION_INFO);
export const SET_GITHUB_AUTHENTICATION_ACTION_TYPE = apiType(SET_GITHUB_AUTHENTICATION);
export const DELETE_GITHUB_AUTHENTICATION_ACTION_TYPE = apiType(DELETE_GITHUB_AUTHENTICATION);
